import * as React from 'react';
import './table.css';

import styled from 'styled-components';
import { Theme } from 'containers/app/themes';

const ETableHeaderUnstyled: React.FC<React.PropsWithChildren<{className?: string}>> = (props) => (
  <div className={`eTableHeader ${props.className}`}>
    {props.children}
  </div>
);

const ETableHeader = styled(ETableHeaderUnstyled)`
  ${({ theme }: { theme: Theme }) => `
    color: ${theme.tableHeader.color};
  `}
`;

export default ETableHeader;
